import React, { useEffect, useState } from 'react';
import './index.scss'
import openKugouApp from "@kugou/open-kugou-app"
import share from '@kugou/share'
import {getAllUrlParams, json2keyval, getQueryString, openKg, replaceHttpsImg} from '../../Utils/Utils'
import history from '../../History'
import Dialog from '../../Components/Dialog'
import Carousel from './Carousel/Index'
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react';
import LightMobileCall from '@kugou/light-mobilecall';
import WxFocus from './WxFocus/Index'
import { checkSingerFollow, followSinger, unfollowSinger, initBaseInfo, fetchSong } from './api/index'
import AudioPlayer from '@kugou/audio-player'
import e from '../../Utils/Event'
import mobileLog from '../../Utils/Utils/mobileLog';

let swiperRef = React.createRef()
let noSwiping = false
const gxhList = [
  require('./images/gxh1.png'),
  require('./images/gxh2.png'),
]

function shareInit(){
  share.resetShareData({
    title: "酷狗音乐开放平台 | 一站式音乐服务平台，助音乐人从成长到成名",
    url: "https://h5.kugou.com/apps/musician-enter/build/index.html",
    content: "从词曲生产到歌曲转授，为入驻音乐人提供全方位音乐服务",
    img: "https://webvoobssdl.kugou.com/24d24b8dce761f7d20abd63d0e6fc381.jpg"
  })
}

//分享参数设置
setTimeout(() => {
  shareInit()
}, 500)

class Home extends React.Component{
  constructor(props) {
    super(props); //传递props给component
    this.state = {
      title: "提示",
      left: false,
      dialogFromUrl: "",
      dialogFromUrlCon: "",
      platform: false,
      wxFocusShow: false,
      singerList: [{
        id: 1054058,
        followed: false
      },{
        id: 810483,
        followed: false
      },{
        id: 6074889,
        followed: false
      },{
        id: 719301,
        followed: false
      },{
        id: 85805,
        followed: false
      },{
        id: 721975,
        followed: false
      }],
      followMap: {
        1054058: undefined,
        810483: undefined,
        6074889: undefined,
        719301: undefined,
        721975: undefined,
        85805: undefined
      },
      songList: [],
      songFetch: false,
      songFetchErr: '',
      playingHash: ''
    };
  }

  goEnter() {
    mobileLog({
      a: 21394,
      b: '点击',
      ft: '音乐人入驻',
      r: '手机页立即认证'
    })


    // 端外拉起
    if (!window.LC.isInClient()) {
      return openKugouApp("303", 9, 0, {
        url: window.location.href,
        title: document.title
      })
    }


    window.$mustLogin(() => {
      window.$getUserStatus(({ status, users }) => {
        window.$player.pause()
        //非注销机构
        let findItem = users && JSON.stringify( users ) !== '{}' && users.find( ele => ( ele.role === 2 ) && ( ele.status !== -1 ) );
        if ( findItem ) {
          //mobileCmd.savePreReturnPage
          window.LC.mobileCall(710, { type: 1 });
          //机构身份,直接跳过去
          window.location.replace( 'https://activity.kugou.com/vo-activity/bd0c1520-722a-11ea-bd83-e73dc97ba287/index.html' )
          return;
        }
        // 入驻成功的，直接跳转去数据页
        if (~[1, 3, 4, 21, 31].indexOf(status)) {
          //透传所有url参数
          let params = getAllUrlParams();
          window.$goToPage('https://h5.kugou.com/musicianService/v-6d9959c0/index.html?isHideTitleBar=1&type=1&norule=1'+(Object.keys(params).length?'&'+json2keyval(params):''))
          return;
        } else if (status < 1000000 && status !== 0 && status !== 50) {
          let path = '/enter/' + window.encodeURIComponent(JSON.stringify({ status }))
          history.go(path)
        } else {
          history.go('/enter-choose')
        }
      })
    })
  }

  toShare() {
    mobileLog({
      a: 21583,
      b: '点击',
      ft: '星曜计划',
      r: '分享'
    })
    share.shareAll()
  }

  wxFocusHide = ()=>{
    this.setState({
      wxFocusShow: false
    })
  }
  showPlatform = ()=>{
    this.setState({
      platform: true
    })
  }
  QYD = ()=>{
    // 端外拉起
    if (!window.LC.isInClient()) {
      return openKugouApp("303", 9, 0, {
        url: window.location.href,
        title: document.title
      })
    }
    if(LightMobileCall.isIOS){
      this.setState({
        wxFocusShow: true
      })
    }else{
      LightMobileCall.mobileCall(123, {
        url: "https://qiyinda.kugou.com/da/v-5835b8ea/index.html?hreffrom=kaiping"
      })
    }
  }
  YSD = ()=>{
    // 端外拉起
    if (!window.LC.isInClient()) {
      return openKugouApp("303", 9, 0, {
        url: window.location.href,
        title: document.title
      })
    }
    LightMobileCall.mobileCall(269, {
      type: 0,
      //正式
      id: 'gh_8bd8f90b5155',
      ver: 0,
      url: '',
      path: "/pages/distrInfoPage/distrInfoPage",
    });
  }
  checkFollowStatus = async (id)=>{
    const baseInfo = await initBaseInfo();
    if(!baseInfo.userid){
      return;
    }
    if(id){
      let is = false;
      const res = await checkSingerFollow(id);
      if (res && res.status) {
        is = !!(res && res.data && res.data.is_follow);
      }
      return is
    }else{  
      let _singerList = await this.checkAll();
      this.setState({
        singerList: _singerList
      })
      this.forceUpdate()
    }
  }
  checkAll(){
    const {singerList} = this.state;
    let _singerList = singerList;
    return new Promise(async (resolve, reject) => {
      _singerList.map(async (item, index) => {
        let is = false;
        const res = await checkSingerFollow(item.id);
        if (res && res.status) {
          is = !!(res && res.data && res.data.is_follow);
        }
        item.followed = is;
        this.setState((state)=>{
          state.followMap[item.id] = is;
          return state;
        })
      });
      resolve(_singerList)
    })
  }
  toggleFollow = async (id) => {
    if (!LightMobileCall.isInClient()) {
      return openKugouApp("303", 9, 0, {
        url: window.location.href,
        title: document.title
      })
    }
    window.$mustLogin(async () => {
      const {followMap} = this.state;
      let status = false;
      if (typeof followMap[id] !== 'undefined') {
        status = followMap[id];
      } else {
        status = await this.checkFollowStatus(id);
      }
      let newStatus = -1; // 查询状态的接口似乎有延迟，采用手动更新方法
      if (status) {
        const res = await unfollowSinger(id);
        if (res && res.status == 1) {
          newStatus = false;
          LightMobileCall.mobileCall(995, {
            msg: '取消关注成功',
          });
        }
      } else {
        const res = await followSinger(id);
        if (res && res.status == 1) {
          newStatus = true;
          LightMobileCall.mobileCall(995, {
            msg: '关注成功',
          });
        }
      }
      if (~newStatus) {
        this.setState((state)=>{
          state.followMap[id] = newStatus;
          state.singerList.map((_)=>{
            if(_.id == id){
              _.followed = newStatus;
            }
            return _;
          })
          return state;
        })
      }
    })
  }

  async songInit(){
    const res = await fetchSong().catch(()=>{
      this.setState({
        songFetchErr: "网络错误，请稍后重试~"
      })
      return null;
    })
    console.log(res);
    if(res){
      if(res.status == 1){
        const list = res.data.songs;
        let temp = [];
        let len = list.length;
        let glen = 6;
        //每9个分成一组
        for (let j = 1; j < glen; j++) {
          temp[j-1] = [];
          for (let i = 0; i < len; i++) {
            if( i >= 9*(j-1) && i < 9*j ){
              temp[j-1].push( list[i] )
            }
          }
        }
        console.log(temp);
        
        this.setState({
          songFetchErr: '',
          songList: temp
        })
      }else{
        this.setState({
          songFetchErr: res.errmsg || '歌曲列表获取失败~点击重试'
        })
      }
    }
  }

  playerInit(){
    window.$player = new AudioPlayer({
      infoFix: {
        audition: 3
      },
      sectionListen: true,
      reqLoading: true,
      errorToastMap: {
        10031: {//vip试听
          message: '版权收费',
          toast: '会员专属歌曲试听中，开通会员畅享完整版'
        },
        1003: {
          message: '版权收费',
          toast: '因版权方要求，需购买即可无限畅享'
        }
      },
      playStatus: (res)=>{
        let { status, hash } = res;
        if(+status == 1){
          this.setState({
            playingHash: hash
          })
        }else{
          this.setState({
            playingHash: ''
          })
        }
      }
    })
  }

  componentDidMount(){
    shareInit()
    setTimeout(() => {
      shareInit()
    }, 1000);
    this.checkFollowStatus()
    this.songInit()
    this.playerInit()
    
    mobileLog({
      a: 21395,
      b: '曝光',
      ft: '音乐人入驻',
      r: '手机主页'
    })
    let coversongtip = getQueryString('coversongtip')
    let uploadSongTip = getQueryString('uploadSongTip')
    if((coversongtip || uploadSongTip) && !window.TipFromUrl){
      window.TipFromUrl = true;
      let con;
      if(coversongtip){
        con = `<p>1.请先入驻为<em>酷狗音乐人</em>；</p>
        <p>2.电脑端登录酷狗音乐开放平台（<em>musician.kugou.com</em>）点击“<em>翻唱福利</em>”，上传正版化翻唱歌曲，即可获得<em>10%</em>歌曲收益。</p>`
        this.setState({
          left: true,
          title: '上传翻唱'
        })
      }else{
        con = '入驻成为酷狗音乐人后，即可上传作品获得版权分成哦'
      }
      this.setState({
        dialogFromUrl: true,
        dialogFromUrlCon: con
      })
    }
    if(getQueryString( 'tleft' )){
      this.setState({
        left: true,
      })
    }
    let manageTip = getQueryString( 'manageTip' );
    if ( manageTip && !window.TipFromUrl ){
      window.TipFromUrl = true;
      let con = '<p>请先入驻成为音乐人，入驻后即可管理自己的作品~</p>';
      this.setState({
        dialogFromUrlCon: con,
        dialogFromUrl: true
      })
    }
    let singTip = getQueryString( 'singTip' );
    if ( singTip && !window.TipFromUrl ){
      window.TipFromUrl = true;
      let con = parseInt(singTip) == 1 ? '<p>请先入驻成为酷狗音乐人<br/>即可在启明星交易词曲噢~</p>':'<p>请先入驻成为酷狗音乐人<br/>就可以在启明星交易词曲、接单做任务啦~</p>'
      this.setState({
        dialogFromUrlCon: con,
        dialogFromUrl: true
      })
    }
    let cqTip = getQueryString( 'cqTip' );
    if ( cqTip && !window.TipFromUrl ){
      window.TipFromUrl = true;
      let con = `<p>1.入驻酷狗音乐人-<em>词曲作者</em>；</p>
      <p>2.电脑端登录酷狗音乐开放平台（<em>musician.kugou.com</em>）点击<em>“出售词曲”，</em>上传未发行的词曲demo（不会对外发行），出售成功可获<em>100%</em>成交价；</p>
      <p>3.审核通过的作品还将进行综合评选，择优收录进<em>伯乐计划首张专辑</em>！</p>`
      
      this.setState({
        title: '出售词曲',
        dialogFromUrlCon: con,
        dialogFromUrl: true,
        left: true
      })
    }
    let claimSongTip = getQueryString( 'claimSongTip' );
    if ( claimSongTip && !window.TipFromUrl ){
      window.TipFromUrl = true;
      let con = `<p>1.请先入驻为<em>酷狗音乐人</em>；</p>
      <p>2.电脑端登录酷狗音乐开放平台（<em>musician.kugou.com</em>）点击“<em>认领词曲</em>”，最高可获<em>16%</em>版税收益；</p>
      <p>3.审核通过后，可在开放平台<em>【收入概览】</em>看到您的词曲收益。</p>`
      
      this.setState({
        title: '认领词曲',
        dialogFromUrlCon: con,
        dialogFromUrl: true,
        left: true
      })
    }
    let mInfotip = getQueryString( 'mInfotip' );
    if ( mInfotip && !window.TipFromUrl ){
      window.TipFromUrl = true;
      let con = `<p style="text-align:center">入驻酷狗音乐人后即可修改歌手资料</p>`

      this.setState({
        title: '提示',
        dialogFromUrlCon: con,
        dialogFromUrl: true,
        left: true
      })
    }
    let goEnterTip = getQueryString( 'goEnterTip' );
    if ( goEnterTip && !window.TipFromUrl ){
      window.TipFromUrl = true;
      let con = `<p>1.请先入驻<em>酷狗音乐人</em>；</p>
      <p>2.签约独家单曲，年总收入<em>20万元</em>以内，平台不分成<em>100%</em>都归你；</p>
      <p>3.签约独家音乐人，年总收入<em>100万元</em>以内，平台不分成<em>100%</em>都归你。</p>`
      
      this.setState({
        title: '提示',
        dialogFromUrlCon: con,
        dialogFromUrl: true,
        left: true
      })
    }
    let uploadCqTip = getQueryString( 'uploadCqTip' );
    if ( uploadCqTip && !window.TipFromUrl ){
      window.TipFromUrl = true;
      let con = `<p style="text-align:center">请先入驻成为酷狗音乐人，入驻后即可上传词曲售卖</p>`

      this.setState({
        title: '提示',
        dialogFromUrlCon: con,
        dialogFromUrl: true,
        left: true
      })
    }
    //弹窗从url获取的提示
    let enterTip = getQueryString('enterTip')
    let enterTipCon = getQueryString('enterTipCon')
    let bothTip = getQueryString('bothTip')
    let bothTipCon = getQueryString('bothTipCon')
    if((enterTip && enterTipCon) || (bothTip && bothTipCon)){
      if( !window.TipFromUrl ){
        //replace(/%/g, '%25') : 解决浏览器在对“%”执行decodeURIComponent时报错
        let con = enterTipCon ? window.decodeURIComponent(enterTipCon.replace(/%/g, '%25')) : window.decodeURIComponent(bothTipCon.replace(/%/g, '%25'))
        con = con.replace('音乐人网址','https://musician.kugou.com/<br/>')
        window.TipFromUrl = true;
        this.setState({
          dialogFromUrlCon: con,
          dialogFromUrl: true,
        })
      }
    }
  }

  componentWillUnmount(){
    
  }

  setDialogFromUrl(BO){
    this.setState({
      dialogFromUrl: BO
    })
  }

  handlePlay(item){
    console.log('%c [ item ]-447', 'font-size:13px; background:pink; color:#bf2c9f;', item)
    if(this.state.playingHash == item.hash){
      window.$player.pause()
      return;
    }
    window.$player.play({
      album_audio_id: item.mixsongid,
      hash: item.hash,
      album_id: 0
    })
  }

  render() {
    const {platform, singerList, wxFocusShow, title, dialogFromUrl, 
    dialogFromUrlCon, left, followMap, songFetchErr, songList, playingHash} = this.state;

    return (<div className="Home">
      <div className="inner-scroll">
        <div className="bg-box"> 
          <img className="bbg bg1" src={require('./images/bg1.jpg')} onLoad={()=>{
            LightMobileCall.mobileCall(1203)
          }} onError={()=>{
            LightMobileCall.mobileCall(1203)
          }}/>
        </div>
        <div className="bg-box"> 
          <img className="bbg bg2" src={require('./images/bg2.jpg')} />
        </div>
        <div className="bg-box"> 
          <img className="bbg bg3" src={require('./images/bg3_1.jpg')} />
        </div>
        <div className="bg-box"> 
          <img className="bbg bg3" src={require('./images/bg3_2.jpg')} />
        </div>
        <div className="bg-box bg-box4_1"> 
          <img className="bbg bg4_1" src={require('./images/bg4_1.jpg')} />
          {platform && <div className="platform-bg"></div>}
          <div className="inner">
            <div className="platform platform1"></div>
            {platform && <div className="platform platform2"></div>}
            {!platform && <div className="btn" onClick={()=>{
              this.showPlatform()
            }}>查看更多主流平台</div>}
          </div>
        </div>
        <div className="bg-box"> 
          <img className="bbg bg4_2" src={require('./images/bg4_2.jpg')} />
        </div>
        <div className="bg-box"> 
          <img className="bbg bg5" src={require('./images/bg5.jpg')} />
          <div className="inner">
            <div className="gxh-wrap">
              <Swiper
                className='swiper'
                ref={swiperRef}
                modules={[Navigation, Pagination, A11y, Autoplay]}
                spaceBetween={0}
                slidesPerView={1}
                centeredSlides={true}
                loop
                noSwiping={noSwiping}
                navigation={{
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                }}
                pagination={{//小圆点配置
                  clickable: true,
                  el: '.swiper-pagination',
                  bulletActiveClass: 'swiper-pagination-bullet-active',
                  bulletClass: 'swiper-pagination-bullet',
                }}
                autoplay={false}
              >
                {gxhList.map((item, index) =>
                  <SwiperSlide className={`swiperSlide ${noSwiping && 'swiper-no-swiping'}`} key={index} >
                    <img src={item} alt='' ></img>
                  </SwiperSlide>)
                }
                <div className={`swiper-pagination ${noSwiping && 'swiper-no-swiping'}`} >
                </div>
              </Swiper>
            </div>
          </div>
        </div>
        <div className="bg-box"> 
          <img className="bbg bg6" src={require('./images/bg6.jpg')} />
          <div className="btn2" onClick={()=>{
            window.$goToPage('https://m3ws.kugou.com/mtpls/topic/617bc63fdea80bbac5a7df7b.html?hreffrom=kaiping')
          }}>了解更多详情</div>
        </div>
        <div className="bg-box bg-box7"> 
          <img className="bbg bg7" src={require('./images/bg7.jpg')} />
          <div className="inner">
            <div className="song-wrap">
              {!songFetchErr && songList.length > 0 && <Swiper
                className='swiper'
                ref={swiperRef}
                modules={[Navigation, Pagination, A11y, Autoplay]}
                spaceBetween={0}
                slidesPerView={1}
                centeredSlides={true}
                loop
                noSwiping={noSwiping}
                navigation={{
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                }}
                pagination={{//小圆点配置
                  clickable: true,
                  el: '.swiper-pagination',
                  bulletActiveClass: 'swiper-pagination-bullet-active',
                  bulletClass: 'swiper-pagination-bullet',
                }}
                autoplay={false}
              >
                {songList.map((item, index) =>
                  <SwiperSlide className={`swiperSlide ${noSwiping && 'swiper-no-swiping'}`} key={index} >
                    <div className="song-box">
                      {item.map((_, _index)=>{
                        let pic = (_.album_cover || _.pic).replace("{size}", 240) || 'https://webimg.kgimg.com/290c4cb38eadf8ddf71d8bca8de8aa56.png'
                        return <div key={_index} className='song'>
                          <div className="pic-box">
                            <img src={replaceHttpsImg(pic)} alt="" className="song-pic" />
                            <div className={"play-status "+((playingHash.toLowerCase() == _.hash.toLowerCase())?"paused":"play")} onClick={()=>{
                              this.handlePlay(_)
                            }}></div>
                          </div>
                          <div className="song-name">{_.songname}</div>
                          <div className="singer-name">{_.author_name}</div>
                        </div>
                      })}
                    </div>
                  </SwiperSlide>)
                }
                <div className={`swiper-pagination ${noSwiping && 'swiper-no-swiping'}`} >
                </div>
              </Swiper>}
              {songFetchErr && <div className="err-tip" onClick={()=>{
                this.songInit()
              }}>
                {songFetchErr || "歌曲列表获取失败~点击重试"}
              </div>}
            </div>
            <div className="btn" onClick={()=>{
              window.$goToPage('https://activity.kugou.com/voo/v-6b8ed6d1/index.html')
            }}>了解更多详情</div>
          </div>
        </div>
        <div className="bg-box"> 
          <img className="bbg bg8" src={require('./images/bg8.jpg')} />
          <div className="btn bg8btn1" onClick={()=>{
            this.QYD()
          }}>立即查看</div>
          <div className="btn bg8btn2" onClick={()=>{
            this.YSD()
          }}>立即查看</div>
        </div>
        <div className="bg-box"> 
          <img className="bbg bg9" src={require('./images/bg9.jpg')} />
          <div className="inner">
            <div className="carsousel-wrap">
              <Carousel></Carousel>
            </div>
          </div>
        </div>
        <div className="bg-box bg-box10"> 
          <img className="bbg bg10" src={require('./images/bg10_1.jpg')} />
          <img className="bbg bg10" src={require('./images/bg10_2.jpg')} />
          {singerList.map((item,index)=>{
            return <div key={index} className={`focus focus${index+1} `+(followMap[item.id]?"focused":"")} onClick={()=>{
              this.toggleFollow(item.id)
            }}></div>
          })}
        </div>
      </div>

      {/* <div className="to-know-btn xinyao" onClick={() => {
        mobileLog({
          a: 21859,
          b: '点击',
          ft: '星耀计划了解详情按钮',
          r: '音乐人入驻页面'
        })
        window.$goToPage('https://mtpls.kugou.com/topic/5e609d3cdea80b211d1e24eb.html')
      }}>了解详情</div>
      <div className="to-know-btn bole" onClick={() => {
        window.$goToPage('https://activity.kugou.com/boleProject/v-a96ba8c0/index.html')
      }}>了解详情</div>
      <div className="to-know-btn yiyuan" onClick={() => {
        mobileLog({
          a: 21858,
          b: '点击',
          ft: '亿元计划了解详情按钮',
          r: '音乐人入驻页面'
        })
        window.$goToPage('https://m3ws.kugou.com/mtpls/topic/6139cd0edea80bd3e4a7df77.html')
      }}>了解详情</div>
      <div className="to-know-btn changpian" onClick={() => {
        window.$goToPage('https://m3ws.kugou.com/mtpls/topic/5f104d17dea80ba8d7c3f266.html')
      }}>了解详情</div>
      <div className="to-know-btn kdjili" onClick={() => {
        window.$goToPage('https://m3ws.kugou.com/mtpls/topic/60af6c9ddea80be939c3f268.html')
      }}>了解详情</div> */}
      <div className="share" onClick={()=>{
        this.toShare()
        // e.emit('loading', { loading: true, text: '识别中' })
        // e.emit('loading', true)
      }}></div>
      <div className="btn-box">
        <div className="btn" onClick={()=>{
          this.goEnter()
        }}></div>
      </div>
      <Dialog 
        title={title||"提示"} 
        titleStyle={{margin:0,padding:"0.4rem 0 0.3rem"}} 
        visible={dialogFromUrl} 
        setVisible={this.setDialogFromUrl.bind(this)} 
        btns={window.LC.isInClient()?[{ text: '知道了', fn: () => this.setDialogFromUrl(false) }]:[{ text: '打开酷狗查看', fn: () => {this.setDialogFromUrl(false);openKg()} }]}>
        <div className={left ? "urlTip left" : "urlTip"}>
          <div dangerouslySetInnerHTML={{__html: dialogFromUrlCon}}></div>
        </div>
      </Dialog>
      {<WxFocus show={wxFocusShow} hideFn={this.wxFocusHide.bind(this)}></WxFocus>}
    </div>)
  }
}

export default Home